import { render, staticRenderFns } from "./Menu1.vue?vue&type=template&id=bba3e874&scoped=true&"
import script from "./Menu1.vue?vue&type=script&lang=js&"
export * from "./Menu1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba3e874",
  null
  
)

export default component.exports